import {
	CHANGE_ACTIVE_TAB,
	CHANGE_OVERVIEW_POLICY_FIELD, CHANGE_OVERVIEW_TAB_READ_MORE_STATE, CHECK_USER_OVERVIEW_TAB_CHECKBOX,
	FAILED_TO_GET_APPLICATION_OVERVIEW, FAILED_TO_GET_OVERVIEW_VISIBILITY_OPTIONS, LOGOUT,
	OVERVIEW_POLICY_ATTACHMENTS_CHANGE,	OVERVIEW_TAB_PAGE_SHIFT, RECEIVE_BAD_REQUEST_POST_OVERVIEW_POLICY_FORM, 
	RECEIVE_GET_APPLICATION_OVERVIEW, RECEIVE_OVERVIEW_VISIBILITY_OPTIONS, RECEIVE_POST_OVERVIEW_POLICY_FORM,
	REQUEST_GET_APPLICATION_OVERVIEW, REQUEST_POST_OVERVIEW_POLICY_FORM, OVERVIEW_TAB_FILTER_VISIBILITY_RESET,
	ADD_ANOTHER_OVERVIEW_ATTACHMENT, CHANGE_OVERVIEW_ATTACHMENT, REMOVE_OVERVIEW_ATTACHMENT, 
	GET_OVERVIEW_TAB_TAGS_DESCRIPTION, GET_OVERVIEW_TAB_TAGS_DESCRIPTION_FAIL, GET_OVERVIEW_TAB_TAGS_DESCRIPTION_SUCCESS,
	GET_OVERVIEW_TAB_SIZE_LIMIT_DESCRIPTION, GET_OVERVIEW_TAB_SIZE_LIMIT_DESCRIPTION_SUCCESS, GET_OVERVIEW_TAB_SIZE_LIMIT_DESCRIPTION_FAIL,
} from "../actions/index";

const defaultState = {
    fetching: false,
    comments: '',
    posting: false,
    attachment: {},
    attachments: [
		{attachment: {}, tags: ''}
	],
    badResponse: '',
    badMsg: '',
    tags: '',
    msg: '',
    applicationOverview: [],
    readMore: {},
    uploadLabel: 'Drag and drop.',
	overviewfilterBy: {},
	includeNoChanges: false,
	wasFilterButtonPressed: false,
	selectedView: 10,
    page: 1,
    totalBoxes: 1,
    sendEmailNotification: false,
	tagsDescription: '',
	sizeLimitDescription: '',
	fetchingFiltered: false,
	fetchingTagsDescription: false,
	fetchingSizeLimitDescription: false,
	fetchingOverviewErrorMessage: '',
	overviewVisibilityOptions: [],
};


export default (state = defaultState, action) => {
	switch (action.type) {
		case CHANGE_OVERVIEW_ATTACHMENT:
			let attch = state.attachments.map(a => ({attachment: {...a.attachment}, tags: a.tags}));
            attch[action.payload.attachmentIndex][action.payload.key] = action.payload.value;
			return {
				...state,
                attachments: attch
			};
		case REMOVE_OVERVIEW_ATTACHMENT:
			let overViewAttachments = [...state.attachments];
            overViewAttachments.splice(action.payload.attachmentIndex, 1);
			return {
				...state,
				attachments: overViewAttachments
			};
		case ADD_ANOTHER_OVERVIEW_ATTACHMENT:
			return {
				...state,
				attachments: [...state.attachments, {attachment: {}, tags: ''}]
			};
		case GET_OVERVIEW_TAB_SIZE_LIMIT_DESCRIPTION:
			return {
				...state,
				fetchingSizeLimitDescription: true
			};
		case GET_OVERVIEW_TAB_SIZE_LIMIT_DESCRIPTION_SUCCESS:
		    let sizeLimitDes;
		    try {
		        sizeLimitDes = action.payload.body.body;
            }
            catch (e){ sizeLimitDes = defaultState.sizeLimitDescription}
			return {
				...state,
				fetchingSizeLimitDescription: false,
                sizeLimitDescription: sizeLimitDes
			};
		case GET_OVERVIEW_TAB_SIZE_LIMIT_DESCRIPTION_FAIL:
			return {
				...state,
				fetchingSizeLimitDescription: false
			};
		case GET_OVERVIEW_TAB_TAGS_DESCRIPTION:
			return {
				...state,
				fetchingTagsDescription: true
			};
		case GET_OVERVIEW_TAB_TAGS_DESCRIPTION_SUCCESS:
		    let tagsDes;
		    try {
		        tagsDes = action.payload.body.body;
            }
            catch (e){ tagsDes = ''}
			return {
				...state,
				fetchingTagsDescription: false,
                tagsDescription: tagsDes
			};
		case GET_OVERVIEW_TAB_TAGS_DESCRIPTION_FAIL:
			return {
				...state,
				fetchingTagsDescription: false
			};
		case CHECK_USER_OVERVIEW_TAB_CHECKBOX:
			let newSendEmailNotification = state.sendEmailNotification;
			if(action.payload !=="all"){
				newSendEmailNotification = false;
			}
			return {
				...state,
				badMsg: '',
				msg: '',
        sendEmailNotification: newSendEmailNotification
			};
		case OVERVIEW_TAB_PAGE_SHIFT:
			if (action.payload.direction === 'left' && state.page > 1)
				return {
					...state,
					page: state.page - 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else if (action.payload.direction === 'right' && state.page < action.payload.totalPaginationBoxes)
				return {
					...state,
					page: state.page + 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else return {
					...state,
					totalBoxes: action.payload.totalPaginationBoxes
				};
		case RECEIVE_GET_APPLICATION_OVERVIEW:			
			let totalDisplayBoxes = Math.ceil(action.payload.totalRecords / parseInt(state.selectedView));
			let currentPage = state.page;
			if(state.page > totalDisplayBoxes && totalDisplayBoxes !== 0){
				currentPage = totalDisplayBoxes;
			}
			let readMore = {};
			try {
				action.payload.forEach(element => {
					readMore = {...readMore, [element.id]: false}
				})
			} catch (e) {
				readMore = {};
			}
			return {
				...state,
				applicationOverview: action.payload.data,
				readMore: readMore,
				fetching: false,
				totalBoxes: totalDisplayBoxes,
				totalRecords: action.payload.totalRecords,
				page: currentPage
			};
		case REQUEST_GET_APPLICATION_OVERVIEW:
			return {
				...state,
				fetching: true,
                fetchingOverviewErrorMessage: defaultState.fetchingOverviewErrorMessage
			};
		case FAILED_TO_GET_APPLICATION_OVERVIEW:
			let failToGetApplicationOverviewMessages = '';
			try {
                failToGetApplicationOverviewMessages = action.payload.response.body.message
			} catch (e) {
                failToGetApplicationOverviewMessages = 'Failed to fetch overview comments. Please try again later';
            }
			return {
				...state,
				fetching:false,
                fetchingOverviewErrorMessage: failToGetApplicationOverviewMessages
			};
		case CHANGE_OVERVIEW_POLICY_FIELD:
			if (action.payload.key === 'badMsg')
				return {
					...state,
					msg: '',
					badMsg: action.payload.value
				};
			return {
				...state,
				[action.payload.key]: action.payload.value,
				msg: '',
				badMsg: ''
			};
		case CHANGE_OVERVIEW_TAB_READ_MORE_STATE:
			return {
				...state,
				readMore: {...state.readMore, [action.payload.key]: action.payload.value},
			};
		case REQUEST_POST_OVERVIEW_POLICY_FORM:
			return {
				...state,
				posting: true,
                badMsg: defaultState.badMsg
			};
		case RECEIVE_POST_OVERVIEW_POLICY_FORM:
			return {
				...state,
				posting: false,
				msg: 'Sent Successfully.',
				comments: '',
				attachment: {},
				attachments: defaultState.attachments,
				tags: '',
				uploadLabel: 'Drag and drop.',
				sendEmailNotification: false,
				page: defaultState.page,
				overviewfilterBy: defaultState.overviewfilterBy,
				includeNoChanges: defaultState.includeNoChanges,
			};
		case RECEIVE_BAD_REQUEST_POST_OVERVIEW_POLICY_FORM:
			let overviewPostErrorMessage = '';
			try {
                overviewPostErrorMessage = action.payload.body.message ? action.payload.body.message : action.payload.response.message;
			} catch (e) {
                overviewPostErrorMessage = 'Failed to create comment. Please try again later.'
            }
			return {
				...state,
				posting: false,
				badMsg: overviewPostErrorMessage,
				sendEmailNotification: false
			};
		case OVERVIEW_POLICY_ATTACHMENTS_CHANGE: 
			return {
				...state,
				attachment: action.payload,
				uploadLabel: action.payload.name,
				msg: '',
				badMsg: ''
			}
		case CHANGE_ACTIVE_TAB:
			return {
				...state,
				msg: '',
				badMsg: '',
				sendEmailNotification: defaultState.sendEmailNotification
			};
		case OVERVIEW_TAB_FILTER_VISIBILITY_RESET:
			return {
				...state,
				fetching: defaultState.fetching,
				fetchingFiltered: defaultState.fetchingFiltered,
				fetchingOverviewErrorMessage: defaultState.fetchingOverviewErrorMessage,
				readMore: defaultState.readMore,
				overviewfilterBy: defaultState.overviewfilterBy,
				includeNoChanges: defaultState.includeNoChanges,
				page: defaultState.page,				
				wasFilterButtonPressed: false
			};
		case RECEIVE_OVERVIEW_VISIBILITY_OPTIONS:
			return {
				...state,
				fetching: false,
				overviewVisibilityOptions: action.payload
			};
		case FAILED_TO_GET_OVERVIEW_VISIBILITY_OPTIONS:
			return {
				...state,
				fetching: false
			};
		case LOGOUT:
			return {
				...defaultState
			};
		case '@@router/LOCATION_CHANGE':
			return {
				...defaultState
			};
		default :
			return state
	}
}